module.exports = __webpack_public_path__ + "img/our_vision.86a4e901.png";